'use client'

import Link from 'next/link'
import { useEffect, useState } from 'react'
import { getCartItemCount } from '@/lib/cart'

export default function Navbar() {
  const [cartCount, setCartCount] = useState(0)

  useEffect(() => {
    const updateCount = () => setCartCount(getCartItemCount())
    updateCount()

    // Listen for cart updates
    window.addEventListener('cartUpdated', updateCount)
    return () => window.removeEventListener('cartUpdated', updateCount)
  }, [])

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex justify-between items-center rounded-3xl bg-white shadow-soft px-4 py-3 md:px-6">
          <Link href="/" className="flex items-center">
            <span className="h-12 md:h-16 w-auto flex items-center">
              <img
                src="/assets/SquishPrints_Logo2.png"
                alt="Squish Prints 3D"
                className="h-12 md:h-16 w-auto object-contain"
              />
            </span>
          </Link>

          <div className="flex items-center gap-4 md:gap-6">
            <Link
              href="/shop"
              className="px-4 py-2 rounded-full bg-peach text-gray-800 font-medium hover:bg-cloud transition-colors"
            >
              Toy Box
            </Link>
            <Link
              href="/cart"
              className="relative flex items-center justify-center h-11 w-11 rounded-full bg-bubble text-gray-800 shadow-soft hover:shadow-pop transition-all"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-1 bg-primary text-white text-xs rounded-full h-6 w-6 flex items-center justify-center font-semibold">
                  {cartCount}
                </span>
              )}
            </Link>
          </div>
        </div>
      </div>
    </nav>
  )
}
